import { styled, SxProp, useSx } from 'dripsy';
import React, { MutableRefObject } from 'react';
import { View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

import { LogoView, ILogoViewProps } from '../views/LogoView';

const Container = styled(KeyboardAwareScrollView)({
  flex: 1,
});

function contentContainerStyle(
  props: EdgeInsets,
  isUseVerticalExtraSpace?: boolean,
): SxProp {
  return (theme) => {
    const verticalExtraSpace = isUseVerticalExtraSpace
      ? theme.space.$6
      : 0;

    return {
      justifyContent: 'center',
      alignItems: [null, 'center'],
      flexGrow: 1,
      px: ['$6', '$0'],
      pt: props.top + verticalExtraSpace,
      pb: props.bottom + verticalExtraSpace,
    };
  };
}

const LogoContainer = styled(View)({
  pb: '$8',
});

const ContentContainer = styled(View)({
  width: [null, '40%'],
  maxWidth: [null, 400],
});

export type AuthLayoutChildContainerRefType = View | null;

export interface IAuthFormLayoutProps extends ILogoViewProps {
  children: React.ReactNode;
  childrenContainerRef?: MutableRefObject<AuthLayoutChildContainerRefType>;
  scrollEnabled?: boolean;
  isUseVerticalExtraSpace?: boolean;
}

export function AuthFormLayout({
  children,
  childrenContainerRef,
  scrollEnabled,
  isUseVerticalExtraSpace,
  ...props
}: IAuthFormLayoutProps) {
  const sx = useSx();
  const insets = useSafeAreaInsets();

  return (
    <Container
      scrollEnabled={scrollEnabled}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={sx(
        contentContainerStyle(insets, isUseVerticalExtraSpace),
      )}
    >
      <ContentContainer>
        <LogoContainer>
          <LogoView {...props} />
        </LogoContainer>
        <View ref={childrenContainerRef}>{children}</View>
      </ContentContainer>
    </Container>
  );
}
